import { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'

const useSocket = (url) => {
  const [response, setResponse] = useState(null)
  const socket = useRef(null)
  const [isConnected, setIsConnected] = useState(false)
  const pingServer = useRef(null)


  useEffect(() => {
    if (url && !isConnected) {
      const connect = () => {
        try {
          socket.current = new WebSocket(url)
        } catch (e) {
          toast(e.result.data.message)

        }
      }
      connect()

      if (socket.current) {
        socket.current.onerror = () => {
          socket.current.close();
          connect()
        }

        socket.current.onopen = () => {
          setIsConnected(true)
          pingServer.current = setInterval(function () {
            socket.current.send('ping')
          }, 5000);
        };

        socket.current.onclose = () => {
          clearInterval(pingServer.current)
          setTimeout(() => setIsConnected(false), 100);
          
        };

        socket.current.onmessage = (evt) => {
          setResponse(JSON.parse(evt.data))
        }

      }
    }
  }, [url, isConnected]);

  useEffect(() => {
    return () => {
      if (socket.current) {
        clearInterval(pingServer)
        socket.current.close();
      }
    }
  }, [])

  return response
}

export default useSocket